import React from "react";
import SidebarOption from "../sidebarOption/SidebarOption";
import "./sidebarslider.css";
import HomeIcon from "@material-ui/icons/Home";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import HistoryIcon from "@material-ui/icons/History";
import MusicVideoIcon from "@material-ui/icons/MusicVideo";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import YouTubeIcon from "@material-ui/icons/YouTube";
import TheatersIcon from "@material-ui/icons/Theaters";
import VideogameAssetIcon from "@material-ui/icons/VideogameAsset";
import LiveTvIcon from "@material-ui/icons/LiveTv";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
import SettingsIcon from "@material-ui/icons/Settings";
import FlagIcon from "@material-ui/icons/Flag";
import HelpIcon from "@material-ui/icons/Help";
import FeedbackIcon from "@material-ui/icons/Feedback";
import { SubscriptionOption } from "..";
function SidebarSlider() {
  return (
    <div className="sidebarSlider">
      <div className="sidebarSlider__top">
        <SidebarOption active Icon={HomeIcon} title="Home" />
        <SidebarOption Icon={WhatshotIcon} title="Trending" />
        <SidebarOption Icon={SubscriptionsIcon} title="Subscriptions" />
      </div>
      <div className="sidebarSlider__top">
        <SidebarOption Icon={VideoLibraryIcon} title="Library" />
        <SidebarOption Icon={HistoryIcon} title="History" />
        <SidebarOption Icon={MusicVideoIcon} title="Your videos" />
        <SidebarOption Icon={WatchLaterIcon} title="Watch later" />
        <SidebarOption Icon={ThumbUpIcon} title="Liked videos" />
        <SidebarOption Icon={ExpandMoreIcon} title="Show 55 more" />
      </div>

      <div className="sidebarSlider__top">
        <h3>Subscription</h3>
        <SubscriptionOption
          src="https://yt3.ggpht.com/ytc/AAUvwnhWK9Xr_djNHHAMyCd_2A6ljJlM9A1ob9jpmkTq7ME=s88-c-k-c0x00ffffff-no-rj"
          title="Aaj Tak"
        />
        <SubscriptionOption
          src="https://yt3.ggpht.com/ytc/AAUvwnhioY_MPr7-X3Tyt8ls4kwj4L_cbp0_XoRptx1v=s88-c-k-c0x00ffffff-no-rj"
          title="Best Hindi Songs"
        />
        <SubscriptionOption
          src="https://yt3.ggpht.com/ytc/AAUvwnhKwB5wYNNSBs216xPg26ufXqJm4nJ2RCd5Plw9=s88-c-k-c0x00ffffff-no-rj"
          title="龙梅梅Longmeimei"
        />
        <SubscriptionOption
          src="https://yt3.ggpht.com/ytc/AAUvwnjuW7xayJponfzaVj9UXJ0HHQo-HTWoTN9I0qfGug=s88-c-k-c0x00ffffff-no-rj"
          title="TheEllenShow"
        />
        <SidebarOption Icon={ExpandMoreIcon} title="Show 55 more" />
      </div>
      <div className="sidebarSlider__top">
        <h3>More From Youtube</h3>
        <SidebarOption Icon={YouTubeIcon} title="Youtube Premiun" />
        <SidebarOption Icon={TheatersIcon} title="Films" />
        <SidebarOption Icon={VideogameAssetIcon} title="Gaming" />
        <SidebarOption Icon={LiveTvIcon} title="Live" />
        <SidebarOption Icon={EmojiObjectsIcon} title="Learning" />
      </div>
      <div className="sidebarSlider__top">
        <SidebarOption Icon={SettingsIcon} title="Settings" />
        <SidebarOption Icon={FlagIcon} title="Report history" />
        <SidebarOption Icon={HelpIcon} title="Help" />
        <SidebarOption Icon={FeedbackIcon} title="Send feedback" />
      </div>
    </div>
  );
}

export default SidebarSlider;
